const PREFIX = "myhub:starred-apps:";

export function starredKey(sub: string | undefined): string {
  return `${PREFIX}${sub ?? "anonymous"}`;
}

// Storage can be unavailable (private mode, quota) and its content can be
// anything, so a read never throws and keeps only string ids.
export function readStarred(key: string): ReadonlySet<string> {
  try {
    const parsed: unknown = JSON.parse(localStorage.getItem(key) ?? "[]");
    if (!Array.isArray(parsed)) return new Set();
    return new Set(parsed.filter((v): v is string => typeof v === "string"));
  } catch {
    return new Set();
  }
}

export function writeStarred(key: string, starred: ReadonlySet<string>): void {
  try {
    localStorage.setItem(key, JSON.stringify([...starred]));
  } catch {
    // Starring still works for this session when storage is unavailable.
  }
}

// The starred clients are kept apart from the starred platforms.
export function starredClientsKey(sub: string | undefined): string {
  return `myhub:starred-clients:${sub ?? "anonymous"}`;
}
